import IconButton from "../../components/button/IconButton";
import * as React from "react";
import {useState} from "react";
import {ButtonGroup} from "react-bootstrap";
import ModalForm from "../../components/form/ModalForm";
import{ useModels } from "../../helpers/models";
import SatFormConfig from "./config/SatFormConfig";
import ConfirmIconButton from "../../components/button/ConfirmIconButton";
import {Actions} from "../../../client/Actions";
import ConfirmWithCommentButton from "../../components/button/ConfirmWithCommentButton";
import {getUser, hasFormatsFullAccess} from "../../helpers/jwt";
import { useTranslation } from 'react-i18next';

export function FormatTableActions(props) {
    const models = useModels();
    const { t } = useTranslation();
    const [showSatModal, setShowSatModal] = useState(false);
    const [showMinusModal, setShowMinusModal] = useState(false);
    const [moveComment, setMoveComment] = useState();

    const buttonSize = "md"

    return <div className={"d-flex"}>
        <ButtonGroup>

            <IconButton
                variant={"outline-primary"}
                // className="btn-circle ml-1"
                onClick={() => props.history.push("/format/" + props.row.id)}
                size={buttonSize}
                tooltip={props.row.formatStatus === "CONFIGURATION" && hasFormatsFullAccess() ? t("tooltips.continue_configuration") : t("tooltips.details")}
                icon={props.row.formatStatus === "CONFIGURATION" ? "fa-gear" : models.format.icon}
            />

            <IconButton
                variant={"outline-primary"}
                // className="btn-circle ml-1"
                onClick={() => props.history.push(models.management.url + "/" + props.row.id)}
                size={buttonSize}
                tooltip={models.management.title}
                disabled={props.row.formatStatus === "CONFIGURATION"}
                icon={"fa-bars-progress"}
            />

            {hasFormatsFullAccess() &&
                <>
                    {!props.row.sat?.ok && props.row.formatStatus === "SAT" &&
                        <IconButton
                            variant={"outline-primary"}
                            onClick={() => {
                                setShowSatModal(true)
                            }}
                            size={buttonSize}
                            tooltip={t("common.sat")}
                            disabled={props.row.formatStatus === "CONFIGURATION"}
                            fullIcon={"fa-solid fa-s"}
                        />
                    }

                    {props.row.formatStatus === "WAITING_FOR_MOVING" &&
                        <ConfirmWithCommentButton
                            variant={"outline-primary"}
                            // className="btn-circle ml-1"
                            onConfirm={() => Actions.post("format/" + props.row.id + "/move", {moveComment: moveComment}, () => props.setReload(!props.reload))}
                            size={buttonSize}
                            modalSize={"lg"}
                            comment={moveComment}
                            setComment={setMoveComment}
                            confirmTitle={t("confirmations.pass_to_production_title")}
                            confirmDescription={t("confirmations.are_you_sure_pass_to_production")}
                            tooltip={t("tooltips.pass_to_production")}
                            buttonsConf={{save: t("common.yes"), cancel: t("common.cancel")}}
                            icon={"fa-angles-right"}
                        />
                    }
                    {props.row.formatStatus === "SAT_ACCEPTATION" &&
                        props.row.sat.user !== getUser()
                        &&
                        <ConfirmIconButton
                            variant={"outline-primary"}
                            // className="btn-circle ml-1"
                            onConfirm={() => Actions.post("format/" + props.row.id + "/sat/accept", {}, () => props.setReload(!props.reload))}
                            size={buttonSize}
                            modalSize={"lg"}
                            confirmTitle={t("confirmations.sat_approval_title")}
                            confirmDescription={t("confirmations.are_you_sure_approve_sat")}
                            tooltip={t("tooltips.approve_sat")}
                            icon={"fa-thumbs-up"}
                        />
                    }


                    <ConfirmIconButton
                        variant={"outline-primary"}
                        // className="btn-circle ml-1"
                        onConfirm={() =>
                            Actions.post(
                                `format/withdrawal/${props.row.id}`,
                                {},
                                () => props.setReload(!props.reload),
                                undefined,
                                props.setLoader,
                                {
                                    "423": t("messages.cannot_withdraw_format")
                                }
                            )
                        }
                        size={buttonSize}
                        modalSize={"lg"}
                        confirmTitle={t("confirmations.format_withdrawal_title")}
                        confirmDescription={t("confirmations.are_you_sure_withdraw_format")}
                        tooltip={t("tooltips.format_withdrawal")}
                        icon={"fa-trash"}
                    />

                </>}
        </ButtonGroup>

        <ModalForm

            open={showSatModal}
            setOpen={setShowSatModal}
            shadow={false}
            fields={SatFormConfig(t)}
            setLoader={props.setLoader}
            title={t("common.sat")}
            size={"md"}
            buttonsConf={{
                save: t("status.start")
            }}
            api={"/format/" + props.row.id + "/sat"}
            onFinish={() => {
                props.setReload(!props.reload)
            }}
        />

        <ModalForm

            open={showMinusModal}
            setOpen={setShowMinusModal}
            shadow={false}
            initialData={
                {
                    oldQuantity: props.row.quantity
                }
            }
            setLoader={props.setLoader}
            // fields={FastActingPartQuantityMinusFormConfig}
            title={t("common.issues_history")}
            size={"md"}
            api={"/fastActingPart/" + props.row.id + "/quantity"}
            onFinish={() => {
                props.setReload(!props.reload)
            }}
        />
    </div>;
}